import React from 'react';

import { Lesson, LessonAccessState } from '@/domains';

export const useLessonDisabled = (lesson?: Lesson) => {
  return React.useMemo(() => !!lesson && lesson.access === LessonAccessState.NotAccessible, [lesson]);
};
